<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">No class selected.</b-alert>

          <div v-if="!error && !loading" class="div-section-body" style="padding: 0 2px 0 3px;">

            <b-container fluid class="mt-4">
              <b-row>
                <b-col cols="12">
                  <h4>{{classObj.className}}</h4>
                  <!-- :inner-html.prop instead of v-html -->
                  <!-- <div class="mt-2 txt-class-blurb" :inner-html.prop="this.classObj.blurb | nl2br"></div> -->
                  <div class="mt-2 txt-class-blurb" v-html="nl2br(classObj.blurb)"></div>
                </b-col>
              </b-row>

              <b-row v-if="!enrolled">
                <b-col cols="12">
                  <div class="mt-4 mb-2">
                      <b-button type="button" @click.stop.prevent="gotoClassSSO($event)" variant="danger" block size="lg" class="rounded">
                        Enroll&nbsp;<span class="custom-opacity diagonal-strike">${{ classObj.priceList }}</span>
                        ${{ classObj.price }}
                        <span class="spnLimited">&nbsp;Limited Time Offer</span>
                      </b-button>
                  </div>
                </b-col>
              </b-row>

              <b-row v-if="enrolled">
                <b-col cols="12">
                  <div class="mt-4 mb-2">
                      <b-button type="button" @click.stop.prevent="gotoClassSSO($event)" variant="danger" block size="lg" class="rounded">Continue to Course</b-button>
                  </div>
                </b-col>
              </b-row>

              <certbuttonpremium v-if="examTaken" :c="buildClass()" :s="buildStudentData()"></certbuttonpremium>

              <b-row v-if="!enrolled">
                <!-- <b-col cols="6">
                  <b-button @click="scrollToAnchor('course-preview')" variant="outline-danger" block size="sm" class="custom-radius custom-padding">Watch Course Trailer <b-icon-play-circle-fill class="pl-1"></b-icon-play-circle-fill></b-button>
                </b-col> -->
                <b-col cols="12">
                  <b-button @click="scrollToAnchor('course-lessons')" variant="outline-dark" block size="sm" class="custom-radius custom-padding">Browse Course Modules</b-button>
                </b-col>
              </b-row>

            <!-- Teaser -->
            <b-container v-if="!enrolled" id="course-preview" class="mt-4">
              <h4 class="text-center">Course Preview</h4>
              <div v-if="showVideo">
                <b-embed v-if="showVideo" ref="plyr"
                  type="iframe"
                  aspect="16by9"
                  :src="getVideoUrl"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                ></b-embed>
              </div>
            </b-container>

              <b-row class="mt-3">
                <b-col cols="12">
                  <b-row>
                    <b-col
                      v-for="(card, index) in cards"
                      :key="index"
                      cols="12" sm="6"
                      class="mb-4"
                    >
                      <b-card
                        class="h-100"
                        bg-variant="light"
                        text-variant="dark"
                        block
                      >
                      <h6 class="mb-4 text-muted small">{{ card.title }}</h6>
                      <h4 class="mb-1">{{ card.text }}</h4>
                      </b-card>
                    </b-col>

                    <b-col cols="12" sm="6" class="mb-4">
                      <b-card
                        class="h-100 text-decoration-none card-clickable"
                        bg-variant="danger"
                        text-variant="light"
                        block
                        @click.stop.prevent="gotoClassSSO($event)"
                      >
                        <div v-if="!enrolled">
                          <h6 class="mb-4 small">Limited Time Offer</h6>
                          <h4 class="mb-0"><span class="custom-opacity">{{ classObj.priceDiscountStr }}</span>&nbsp;<b>${{ classObj.price }}</b></h4>
                          <h6 class="mt-4 small">List Price <span class="custom-opacity diagonal-strike">${{ classObj.priceList }}</span></h6>
                        </div>
                        <div v-else>
                          <h6 class="mb-4 small">Status:</h6>
                          <h4 class="mb-0"><b>Enrolled</b></h4>
                          <h6 class="mt-4 small">Valid until: {{ accessExpireDate }}</h6>
                        </div>
                      </b-card>
                    </b-col>

                  </b-row>
                </b-col>
              </b-row>
            </b-container>

            <!-- About the course-->
            <b-container class="mt-4">
              <h2>About the course</h2>
              <div v-html="classObj.description"></div>
            </b-container>

            <!-- Lessons-->
            <b-container class="mt-4" id="course-lessons">
              <h2 class="text-center mb-3">Course Modules</h2>
              <div v-html="classObj.lessonBlurb"></div>
            </b-container>

            <!-- Speaker Info-->
            <b-container fluid class="mt-4">
              <b-row style="padding: 5px 5px 10px 3px;">
                <b-col sm="4" cols="12">
                  <div class="text-center">
                    <b-img fluid v-bind:src="classObj.speakerPhoto" class="mb-2" />
                  </div>
                </b-col>
                <b-col sm="8" cols="12">
                  <div>
                    <h3>{{classObj.name}}</h3>
                    <div v-html="nl2br(classObj.speakerBlurb)"></div>
                  </div>
                </b-col>
              </b-row>
            </b-container>

            <b-row v-if="!enrolled">
              <b-col cols="12">
                <div class="mt-4 mb-2">
                    <b-button type="button" @click.stop.prevent="gotoClassSSO($event)" variant="danger" block size="lg" class="rounded">
                      Enroll
                      <span class="custom-opacity diagonal-strike">${{ classObj.priceList }}</span> ${{ classObj.price }}
                      <span class="spnLimited">&nbsp;Limited Time Offer</span>
                    </b-button>
                </div>
              </b-col>
            </b-row>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service"
import utils from "@/utils/utils"
import constants from "@/config/constants"

import CertButtonPremium from "@/components/CertButtonPremium"

export default {
  name: "ClassroomPremium",
  data() {
    return {
      debug: false,
      error: false,
      loading: true,
      msg: "Classroom Premium",
      blurb: "Classroom blurb.",
      classObj: {},
      studentData: {status: false, gradebookId: 0,  ceTypeId: 1, examTaken: false, examsLeftToday: 10},
      studentHash: this.$root.getToken(),
      classHash: '',
      showVideo: true,
      logging: false
    }
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    enrolled() {
        return Boolean(this.studentData.gradebookId)
    },
    examTaken() {
        return Boolean(this.studentData.examTaken)
    },
    accessExpireDate() {
      return this.studentData.accessExpires  // TBD format and add proper period.
    },
    cards() {
      let cards = [
        { title: "Presenter", text: this.classObj.name },
        { title: "Format", text: "Online Course" },
        { title: "Modules", text: this.classObj.numLessons },
        { title: "CE Credits", text: this.classObj.credits + " Self-Study CEU" },
        { title: "Duration", text: this.classObj.credits + " Hours" },
        { title: "AGD Subject Code", text: this.classObj.agdCode },
        { title: "Full Access", text: "1 Year" }
      ]
      return cards
    },
    enrollUrl() {
      return constants.LEARNWORLDS_BASE.concat(this.classObj.learnworldsClassId)
    },
    hasVideo() {
      let aout = this.classObj.youtubeUrl != null
      // console.log(`hasVideo: ${aout}`)
      return aout
    },
    getVideoUrl() {
      let code = utils.getYoutubeCode(this.classObj.youtubeUrl)
      let url = utils.getYoutubeUrl(code, true)
      return url
      // return 'https://www.youtube.com/embed/zpOULjyy-n8?rel=0'  // reo
      // return 'https://www.youtube.com/embed/pTvxZgiuU3Y?rel=0'
      // return 'https://www.youtube.com/watch?v=pTvxZgiuU3Y&rel=0'  // viva
    },
    btnViewLabel() {
      let txt = ''
      if (this.showVideo) {
        txt = (this.classObj.isTutorial) ? 'Hide Tutorial' : 'Hide Class'
      }
      else {
        txt = (this.classObj.isTutorial) ? 'View Tutorial' : 'View Class'
      }
      return txt
    },
    hasExamsLeftToday() {
      // Returns true if:
      // -- live class
      // -- OnDemand class and studentData.examsLeftToday > 0
      return (this.isLive || (this.studentData.examsLeftToday > 0))
    },
    btnTakeExamDisabled() {
      // Return true if exam button should be disabled.
      // Reasons for disabled:
      // -- classObj.canShowExam is false
      // -- hit daily exams quota
      if (this.debug) console.log(`canShowExam: ${this.classObj.canShowExam}  isLive: ${this.isLive}  hasExamsLeftToday: {this.hasExamsLeftToday}`)
      // return (!this.classObj.canShowExam || (!this.isLive && !this.hasExamsLeftToday))
      return (!this.classObj.canShowExam || !this.hasExamsLeftToday)
    }
  },
  components: {
    'certbuttonpremium': CertButtonPremium,
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    scrollToAnchor(anchorId) {
      const el = document.getElementById(anchorId)
      if (el) {
        el.scrollIntoView({ behavior: "smooth" })
      }
    },
    gotoUrl(url) {
      window.location.href = url
    },
    gotoClassSSO() {
      //
      this.$router.push({ path: `/premium-classroom-sso/${this.classObj.learnworldsClassId}` })
    },
    nl2br(text) {
      if (!text) return '';
      return text.replace(/\n/g, '<br>');
    },
    gotoExam() {
      // Exam flow: affidavit -> eval -> sva/survey -> exam.
      // Student will not have gradebook record until they:
      // 1) start ondemand webinar
      // 2) start live webinar
      this.$router.push({ path: `/affidavit/${this.classHash}` })
    },
    buildClass() {
      let aout = {
        status: true,
        classId: this.classObj.classId,
        agdCode: this.classObj.agdCode,
        agdCategory: this.classObj.agdCategory,
        className: this.classObj.className,
        speakerName: this.classObj.name,
        classHash: this.classObj.hash,
        description: this.classObj.description,
        podcastHash: null,
        isCADentalBoard: this.classObj.isCADentalBoard,
        courseNumberCADentalBoard: this.classObj.courseNumberCADentalBoard
      }
      return aout
    },
    buildStudentData() {
      let aout = {
        status: true,
        hash: this.studentHash,
        name: this.$root.getStudentName(),
        examDate: this.studentData.examDate,
        examDateLocal: this.studentData.examDateLocal,
        credits: this.studentData.credits,
        ceTypeId: this.studentData.ceTypeId
      }
      return aout
    },
    toggleVideo() {
      // console.log(`toggleVideo: ${this.classHash}`)
      if (this.showVideo) {
        this.showVideo = false
      }
      else {
        this.logging = true
        service
          .classView(this.classHash, this.studentHash)
          .then(
            (res => {
              if (this.debug) console.log(res)
              if (res.status) {
                  this.studentData.status = res.status
                  this.studentData.gradebookId = res.gradebookId
                  this.showVideo = true
              }
              else {
                this.error = true
              }
            }).bind(this)
          )
          .finally(e => {
            this.logging = false
          })
          .catch(e => {
            this.error = true
            console.log(e);
          })
      }
    },
    viewPDF() {
      // console.log(`toggleVideo: ${this.classHash}`)
      this.logging = true
      let win = window.open(this.classObj.pdfClassFile, '_blank')
      if (win) win.focus()
      this.logging = false

      service
        .classView(this.classHash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
                this.studentData.status = res.status
                this.studentData.gradebookId = res.gradebookId
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
// Moved this to the top of the method to fix in Safari
// https://stackoverflow.com/questions/20696041/window-openurl-blank-not-working-on-imac-safari
//
//          this.logging = false
          // this.$router.push(this.classObj.pdfClassUrl)
//          let win = window.open(this.classObj.pdfClassFile, '_blank')
//          if (win) win.focus()

        })
        .catch(e => {
          this.error = true
          console.log(e);
        })
    }
  },
  created() {
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || ""
    if (this.classHash) {
      service
        .getClass(this.classHash, this.studentHash)
        .then(
          (data => {
            if (this.debug) console.log(data);
            if (data.status) {
              this.$root.setVersionApi(data.version)
              this.classObj = data.classObj

              // update the title tag
              document.title = "Free Dental CE - " + data.classObj.className
                + " - " + utils.prettyDate(data.classObj.releaseDateUTC)

              let canonical = constants.CANONICAL_BASE + constants.PATHS.ON_DEMAND_BASE + "/" + data.classObj.slug

              let pres = (data.classObj.name != null) ? data.classObj.name : data.classObj.companyName

              // set the meta description
              let desc = utils.leadingWords(pres + " presents: " + data.classObj.blurb, 150)
              let headTag = document.getElementsByTagName('HEAD')[0]
              let tag = document.createElement('meta')
              tag.setAttribute("name", "description")
              tag.setAttribute("content", desc)
              headTag.appendChild(tag)

              // set the canonical tag
              let tag2 = document.createElement('link')
              tag2.setAttribute("rel", "canonical")
              tag2.setAttribute("href", canonical)
              headTag.appendChild(tag2)

              if (data.studentData.status) {
                this.studentData = data.studentData
                if (this.debug) console.log(`Exams Left Today: ${this.studentData.examsLeftToday}`)
              }
            }
            else {
              this.error = true
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false;
          // console.log(`finally...`);
        })
        .catch(e => {
          this.error = true;
          console.log(e);
        });
    } else {
      this.$router.push("exams")
    }
    // this.error = this.$root.getClassId() === 0;

  },
  mounted () { },
  beforeDestroy() {
    // console.log('beforeDestroy')
    this.classObj = {status: false}
    this.studentData = {status: false,  ceTypeId: 1, examTaken: false, examsLeftToday: 10}
    // this.showVideo = false
    this.loading = true
    this.logging = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.thick-outline {
  border-width: 3px !important; /* Increase outline thickness */
}

.custom-opacity {
  opacity: .7;
}

.spnLimited {
  font-size: .8rem;
  font-weight: bold;
}

.custom-radius {
  border-radius: 12px !important;
}

.custom-padding {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.diagonal-strike {
  position: relative;
  display: inline-block;
  /* color: #000; */
}

.diagonal-strike::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #FFF; /* or any color */
  transform: rotate(-20deg);
  transform-origin: center;
}

.card-clickable {
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.card-clickable:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}
</style>



// WEBPACK FOOTER //
// src/components/ClassroomPremium.vue